import { withStyles } from '@material-ui/core';
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'

import { WaitingPassengerOptions as View  } from './WaitingPassengerOptions.js'

import { routeActions } from 'reduxModules/actions/RouteActions.js';
import { isPartnerSelector, isLimitedDispatcherSelector } from 'reduxModules/selectors/UserSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  isPartner: isPartnerSelector,
  isLimitedDispatcher: isLimitedDispatcherSelector,
})

const mapDispatchToProps = {
  deleteWaitingPassenger: routeActions.deleteWaitingPassenger,
  addWaitingPassengerToSheet: routeActions.addWaitingPassengerToSheet,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const WaitingPassengerOptions = enhance(View)


// WEBPACK FOOTER //
// ./src/components/WaitingPassengerOptions/index.js